import { MdCrisisAlert } from "react-icons/md";
import { SiCivicrm } from "react-icons/si";
import { IoCogOutline } from "react-icons/io5";
import { GrMoney } from "react-icons/gr";
import { HiOutlineDocumentReport } from "react-icons/hi";

const sidebar = [
  {
    titleKey: "nav.home",
    title: "Home",
    icon: <SiCivicrm />,
    link: '/accounting/home' 
  },
  {
    titleKey: "sidebar.expenses",
    title: "Expenses",
    icon: <GrMoney />,
    link: '/accounting/expenses'
  },
  // {
  //   titleKey: "accounting.reports",
  //   title: "Reports",
  //   icon: <HiOutlineDocumentReport />,
  //   link: '/accounting/reports'
  // },
  {
    titleKey: "settings.title",
    title: "Settings",
    icon: <IoCogOutline />,
    link: '/accounting/settings',
    fixedBottom: true
  },
  // {
  //   titleKey: "sidebar.chartOfAccounts",
  //   title: "Chart of Accounts",
  //   icon: <MdCrisisAlert />,
  //   link: '/accounting/chart'
  // }
];

export default sidebar;
